<template>
	<div class="p-grid">
		<div class="p-col-12 p-pt-1 p-pb-1 p-mt-3">

          <div class="search-bar" style="float: right">
            <i class="pi pi-search" />
            <InputText v-model="filters['global'].value" :placeholder="$t('analytics.search')" :aria-label="$t('analytics.search')"/>
            <i class="pi pi-times" @click="function() {filters['global'].value=null}"/>
          </div>
          <div class="p-formgroup-inline p-ai-center">
            <div class="p-field">
              <Dropdown id="country" v-model="filters['country'].value" :options="countries" optionLabel="name" optionValue="code"
                :placeholder="$t('analytics.filter_country_ph')" />
            </div>
            <div class="p-field">
              <Dropdown id="city" v-model="filters['city'].value" :options="cities" optionLabel="name" optionValue="code"
                :placeholder="$t('analytics.filter_city_ph')" />
            </div>
          </div>

          <DataTable :value="labs" stripedRows 
            v-model:filters="filters" responsiveLayout="stack" dataKey="id" 
            breakpoint="960px" selectionMode="single" @row-click="openAnalytics">
            <template #empty>
                {{$t('analytics.empty_list')}}
            </template>
            <template #loading>
                {{$t('analytics.loading_list')}}
            </template>

            <Column field="name" :header="$t('analytics.lab_col_name')" ></Column>
            <Column field="country" :header="$t('analytics.lab_col_country')" >
              <template #body="slotProps">
                <span>{{getCountryName(slotProps.data.country)}}</span>
              </template>
            </Column>
            <Column field="city" :header="$t('analytics.lab_col_city')" ></Column>
          </DataTable>


    </div>
	</div>

  <!--        -->
  <!-- ERRORS -->
  <!--        -->
  <IrinoxDialogDark :visible="dialog.error" 
    mode="error" 
    :message="$t('analytics.error_dialog')"
    :life="3000" 
    @update:visible="dialog.error = $event" />
  <IrinoxDialogDark :visible="dialog.blockingError" 
    mode="error" 
    :message="$t('analytics.error_dialog')"
    :life="0" 
    @update:visible="dialog.blockingError = $event" />

</template>

<script>
import ApplianceService from '../../service/ApplianceService';
import CountryService from '../../service/CountryService';
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
// import IrinoxDialogLight from '../IrinoxDialogLight.vue';
import {FilterMatchMode} from 'primevue/api';
import { mapGetters } from 'vuex';

export default {
    components: {
          IrinoxDialogDark,
          // IrinoxDialogLight
    },
    data() {
        return {
          filters: {
              'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
              'country': {value: null, matchMode: FilterMatchMode.EQUALS},
              'city': {value: null, matchMode: FilterMatchMode.EQUALS}
          },
          labs: [],
          serialNumber: null,
          countryList: null,
          countries: [{ 
              code: null,
              name: this.$t('admin.appliances.filter_remove') 
            }],
          cities: [{ 
              code: null,
              name: this.$t('admin.appliances.filter_remove') 
            }],
          dialog: {
            error: false,
            blockingError: false
          }
        };
    },
    computed: {
        ...mapGetters({
          personaltoken: 'userdata/personaltoken',
        }),
    },
    watch: {
    },
    created() {
      this.countryService = new CountryService();
      this.applianceService = new ApplianceService();
    },
    mounted() {
      this.countryService.getCountries().then((countries) => {
          this.countryList = countries;
      });
      this.getLabs();
    },
    methods: {
      getCountryName(code) {
        if(!this.countryList) {
          return code;
        }
        let country = this.countryList.find(obj => obj.code === code);
        if(country && country.name) {
          return country.name;
        }
        return code;
      },
      getLabs() {
        this.$store.commit('appliances/labs', []);
        this.applianceService.getLabs(this.personaltoken)
          .then(labs => {
            let countriesOptions = [{ 
              code: null,
              name: this.$t('admin.appliances.filter_remove') 
            }];
            let citiesOptions = [{ 
              code: null,
              name: this.$t('admin.appliances.filter_remove') 
            }];
            for(let i=0; i<labs.length; i++) {
              if(labs[i].country) {
                let country = this.countryList.find(obj => obj.code === labs[i].country);
                countriesOptions.push({ code: labs[i].country, name: country ? country.name : labs.country });
              }
              if(labs[i].city) {
                citiesOptions.push({ code: labs[i].city, name: labs[i].city });
              }
            }
            this.countries = this.$functions.uniqByKeepFirst(countriesOptions, item => item.code);
            this.cities = this.$functions.uniqByKeepFirst(citiesOptions, item => item.code);
            this.populateLabs(labs);
          })
          .catch(error => {
            console.error("EXCEPTION "+error);
            this.$store.commit('appliances/labs', []);
            this.blockingErrorDialog = true;
          });
      },
      populateLabs(labs) {
        this.labs = labs;
        this.labs.sort((a,b) => this.$functions.compareStrings(a, b, "name"));
        this.$store.commit('appliances/labs', labs);
      },
      openAnalytics(event) {
        this.$router.push({ name: 'lab-analytics', params: { labId: event.data.id }});
      }
    }

}
</script>

<style scoped>

.irinox-form .p-dropdown {
  width: 200px;
}

.irinox-form .search-bar input {
  width: 100px;
}


</style>